import React from 'react';
import { useSelector } from 'react-redux';
import {
	PageTitle,
	PageBreadcrumbs,
	Container,
	SEOText,
	SEOSLPProductSchema,
	NotFound,
} from 'common/components';
import { CategoriesListingSection, pageTitleStyles, seoStyles } from './styled';
import { AdditionalText, Benefits, CategoriesList } from './components';
import { selectConfigurators } from './selectors';

export const CategoriesListing = () => {
	const configurators = useSelector(selectConfigurators);

	return (
		<CategoriesListingSection id="categories-listing">
			<Container>
				<PageBreadcrumbs />
				<PageTitle className={pageTitleStyles} />
				{configurators.length ? (
					<>
						<Benefits />
						<CategoriesList />
					</>
				) : (
					<NotFound
						description={
							'На\u00A0данный момент нет доступных услуг в\u00A0вашем городе'
						}
					/>
				)}
			</Container>
			<AdditionalText />
			<div>
				<SEOSLPProductSchema />
				<SEOText className={seoStyles} />
			</div>
		</CategoriesListingSection>
	);
};
